import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Widget from '../Widget';
import Avatar from '../Avatar';
import Score from '../Score';
import WidgetTable from './Shared/WidgetTable';

export default class MentorLeaderboardWidget extends Component {
  static propTypes = {
    seeMoreUrl: PropTypes.string.isRequired,
    initialConfigurations: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    totalRows: PropTypes.number.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      range: this.props.initialConfigurations.range,
      ascending: this.props.initialConfigurations.sort_by === 'highest_rating',
    };
  }

  // Render Main screen using the data from `run_query`

  renderMainScreen = (data) => (
    <WidgetTable
      headerRow={(
        <tr>
          <th>#</th>
          <th>MENTOR</th>
          <th>SCORE</th>
          {this.state.range !== 'all' && (
          <th>TREND</th>
          )}
        </tr>
        )}
      dataRows={data.map(this.renderRow)}
      seeMoreUrl={this.props.seeMoreUrl} />
  )

  renderRow = (item, index) => {
    const rank = this.state.ascending ? index + 1 : this.props.totalRows - index;
    return (
      <tr key={item.id}>
        <td><span className="u-mr-2">{rank}</span></td>
        <td>{this.renderMentor(item)}</td>
        <td><Score rating={item.rating} /></td>
        {this.state.range !== 'all' && (
          <td>{this.renderRankChange(rank, item.previous_rank)}</td>
        )}
      </tr>
    );
  }

  renderMentor(item) {
    return (
      <a className="u-flex u-items-center" href={item.staff_url}>
        <Avatar
          src={item.avatar.url}
          name={item.full_name}
          className="u-h-6 u-w-6 u-mr-2 u-flex-shrink-0"
        />
        <span className="u-truncate u-w-32">{item.full_name}</span>
      </a>
    );
  }

  renderRankChange(current_rank, old_rank) {
    let delta = 0;
    if (old_rank) {
      const old_rank_fixed = this.state.ascending ? old_rank : this.props.totalRows + 1 - old_rank;
      delta = old_rank_fixed - current_rank;
    }

    if (delta > 0) {
      return (
        <span className="u-font-bold u-text-green">
          <i className="Icon-arrow-up" />
+
          {delta}
        </span>
      );
    } if (delta < 0) {
      return (
        <span className="u-font-bold u-text-red">
          <i className="Icon-arrow-down" />
          {delta}
        </span>
      );
    }
    return (<span className="u-font-bold u-text-grey-darker">⬩</span>);
  }

  // Render Configuration screen

  renderConfigurationScreen = (configs, updateConfigState) => (
    <div>
      <div className="widget-configs-label">Sort by</div>
      {this.renderSortOption(configs, updateConfigState, 'highest_rating', 'Highest rated mentors')}
      {this.renderSortOption(configs, updateConfigState, 'lowest_rating', 'Lowest rated mentors')}
      <div className="widget-configs-label">Date range</div>
      {this.renderRangeOption(configs, updateConfigState, '7', 'Last 7 days')}
      {this.renderRangeOption(configs, updateConfigState, '30', 'Last 30 days')}
      {this.renderRangeOption(configs, updateConfigState, '90', 'Last 90 days')}
      {this.renderRangeOption(configs, updateConfigState, 'all', 'All time')}
    </div>
  )

  renderSortOption = (configs, updateConfigState, ascending, label) => {
    const inputName = `sort_by_${ascending}`;
    return (
      <div className="radio">
        <label htmlFor={inputName}>
          <input
            type="radio"
            name="sort_by"
            id={inputName}
            onChange={() => this.changeSortBy(updateConfigState, ascending)}
            checked={configs.sort_by === ascending}
          />
          {' '}
          {label}
        </label>
      </div>
    );
  }

  changeSortBy = (updateConfigState, sort_by) => {
    this.setState({ ascending: (sort_by === 'highest_rating') }, () => updateConfigState({ sort_by }));
  }

  renderRangeOption = (configs, updateConfigState, range, label) => {
    const inputName = `range_${range}`;
    return (
      <div className="radio">
        <label htmlFor={inputName}>
          <input
            type="radio"
            name="range"
            id={inputName}
            onChange={() => this.changeRange(updateConfigState, range)}
            checked={configs.range === range}
          />
          {' '}
          {label}
        </label>
      </div>
    );
  }

  changeRange = (updateConfigState, range) => {
    this.setState({ range }, () => updateConfigState({ range }));
  }

  render() {
    const title = this.state.range !== 'all' ? `${this.props.title} [Last ${this.state.range} days]` : this.props.title;
    return (
      <Widget
        renderMainScreen={this.renderMainScreen}
        renderConfigurationScreen={this.renderConfigurationScreen}
        {...this.props}
        title={title}
      />
    );
  }
}
